import { render, staticRenderFns } from "./RelatorioGeral.vue?vue&type=template&id=440b92fd"
import script from "./RelatorioGeral.vue?vue&type=script&lang=js"
export * from "./RelatorioGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports